<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong> {{ $t('compGraphicsNationalPlanesPie.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'
import Travel from '@/models/carbon/Travel.js'

export default {
  name: 'NationalPlanesPie',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      options: {}
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t(
            'compGraphicsNationalPlanesPie.national.plane.emissions'
          ),
          y: 0
        },
        {
          name: this.$t('compGraphicsNationalPlanesPie.other.plane.emissions'),
          y: 0
        },
        {
          name: this.$t('compGraphicsNationalPlanesPie.other.emissions'),
          y: 0
        }
      ]
      let planeIntensity = 0
      for (let travel of this.ghgi.travels) {
        let intensity = 0
        let isNational = true
        let hasSectionWithPlane = false
        for (let section of travel.sections) {
          intensity += section
            .getCarbonIntensity(this.ghgi.year)
            .multiply(travel.amount).intensity
          if (section.type !== 'NA') {
            isNational = false
          }
          if (section.transportation === Travel.MODE_PLANE) {
            hasSectionWithPlane = true
          }
        }
        if (hasSectionWithPlane && isNational) {
          series[0].y += intensity
          planeIntensity += intensity
        } else if (hasSectionWithPlane) {
          series[1].y += intensity
          planeIntensity += intensity
        }
      }
      series[2].y = this.ghgi.intensity.intensity - planeIntensity
      return series
    }
  },
  methods: {
    compute () {
      let self = this
      this.options = {
        chart: {
          type: 'pie'
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(self.series[0].y)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        }
      }
    }
  },
  mounted () {
    this.compute()
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
